import React, { useEffect, useRef, useState } from "react";
const spinnerTimeBeforeShow = 400; // (ms)

const Spinner = (props) => {
  const [buffer, setBuffer] = useState(true);
  const ref = useRef(null);
  useEffect(() => {
    if (props.immediateShow) {
      setBuffer(false);
    } else {
      ref.current = setTimeout(() => {
        setBuffer(false);
      }, spinnerTimeBeforeShow);
    }
    return () => {
      if (ref.current) clearTimeout(ref.current);
    };
  }, [props]);

  if (buffer) {
    return (
      <div
        className={`d-flex justify-content-center align-items-center w-100 ${
          props.notFullHeight ? "" : "h-100"
        } ${props.bgDark ? "bg-dark" : ""}`}
      ></div>
    );
  } else {
    return (
      <div
        className={`d-flex justify-content-center align-items-center w-100 ${
          props.notFullHeight ? "" : "h-100"
        } ${props.bgDark ? "bg-dark" : ""}`}
      >
        <div
          className={`spinner-border spinner-width ${
            props.spinnerLight ? "text-light" : ""
          } ${props.small ? "small" : ""}`}
          role="status"
        ></div>
        {props.message ? <span className="ps-3">{props.message}</span> : null}
      </div>
    );
  }
};

export default Spinner;
